import { render, staticRenderFns } from "./listing-task-module.vue?vue&type=template&id=48fedfb4&scoped=true&"
import script from "./listing-task-module.vue?vue&type=script&lang=js&"
export * from "./listing-task-module.vue?vue&type=script&lang=js&"
import style0 from "./listing-task-module.vue?vue&type=style&index=0&id=48fedfb4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fedfb4",
  null
  
)

export default component.exports